import {RoomCamStudy} from "@/core/api/camstudy/room.camstudy.api";
import {CamstudyPersonal} from "@/core/api/camstudy/room.camstudy.personal.api"
import {RoomFile} from '@/core/api/room.file.api'
import {RoomUserVideoTrackFilter} from '@/core/api/camstudy/room.user.videoTrackFilter.api'

const _silent_reload = 'CAMSTUDY_SILENT_RELOAD'
const _my_info_setting = 'CAMSTUDY_MY_INFO_SETTING'
const _attend_check = 'CAMSTUDY_ATTEND_CHECK'
export default {
    initCamStudy: async ({dispatch, commit, rootGetters}) => {
        const CamStudySilentReload = JSON.parse(sessionStorage.getItem('CAMSTUDY_SILENT_RELOAD'))
        if(CamStudySilentReload?.roomId === rootGetters['room/room'].roomId) {
            if(CamStudySilentReload.stopwatchState === 'start') {
                dispatch("changeStopwatchState", 'start')
            }
            sessionStorage.removeItem(_silent_reload)
        }

        const CamStudyInfoSetting = JSON.parse(localStorage.getItem(_my_info_setting))
        if(CamStudyInfoSetting) {
            commit('setMyInfoSetting', CamStudyInfoSetting)
        }
        dispatch('startStopwatchTimer')
    },
    startStopwatchTimer: ({commit, getters}) => {
      // const _stopwatchTimer = () => {
      //     setTimeout(_stopwatchTimer, 1000)
      //     commit('addStopwatchTime')
      // }
      // setTimeout(_stopwatchTimer, 1000)
        clearInterval(getters.__startStopwatchTimer__);
        getters.__startStopwatchTimer__ = setInterval(() => {
            commit('addStopwatchTime')
        }, 1000)
    },
    changeStopwatchState: async ({dispatch, commit, getters, rootGetters }, state) => {
        return await RoomCamStudy.changeStopwatchState(state);
    },
    resetStopwatch: async ({dispatch, commit, getters, rootGetters }, resetData) => {
        return await RoomCamStudy.resetStopwatch(resetData);
    },
    getTodayCamStudyData: async ({dispatch, commit, getters, rootGetters }) => {
        return await RoomCamStudy.getTodayCamStudyData();
    },
    createTodayCamStudyUserData: async ({dispatch, commit, getters, rootGetters }) => {
        return await RoomCamStudy.createTodayCamStudyUserData();
    },
    getCamStudyRoomInfo: async ({dispatch, commit, getters, rootGetters}, roomId) => {
        return await RoomCamStudy.getCamStudyRoomInfo(roomId);
    },
    getCamStudyUserList: async ({dispatch, commit, getters, rootGetters}, roomId) => {
        return await RoomCamStudy.getCamStudyUserList(roomId);    
    },
    modifyCamStudyInfo: async ({dispatch, commit, getters, rootGetters }, data) => {
        return await RoomCamStudy.modifyCamStudyInfo(data);
    },
    getCamStudyUserProfile: async ({dispatch, commit, getters, rootGetters}, { userId, roomId }) => {
        if(!userId) {
            userId = 'me';
        }
        return await RoomCamStudy.getCamStudyUserProfile({ userId, roomId });
    },
    getCamStudyUserBanList: async ({dispatch, commit, getters, rootGetters }) => {
        return await RoomCamStudy.getCamStudyUserBanList();
    },
    addCamStudyUserBan: async ({dispatch, commit, getters, rootGetters }, data) => {
        return await RoomCamStudy.addBanUser(data);
    },
    removeCamStudyUserBan: async ({dispatch, commit, getters, rootGetters }, data) => {
        return await RoomCamStudy.removeBanUser(data);
    },
    addCamStudyUserPoint: async ({}, data) => {
        return await RoomCamStudy.addUserPoint(data)
    },
    getWhiteNoisePlayList: async ({dispatch, commit, getters, rootGetters }) => {
        const playList = getters.whiteNoisePlayList
        if(playList && playList.length > 0) {
            return
        }
        let response = await RoomCamStudy.getWhiteNoisePlayList();
        commit('setWhiteNoisePlayList', response.data)
    },
    getPersonalSetting: async ({ dispatch, commit, getters, rootGetters } ) => {
        if (Object.keys(getters.personalSetting).length) return;
        const personalSetting = await CamstudyPersonal.getPersonalSetting();
        commit('setPersonalSetting', personalSetting);
    },
    modifyPersonalSetting: async ({ dispatch, commit, getters, rootGetters }, modifyData) => {
        const personalSetting = await CamstudyPersonal.modifyPersonalSetting(modifyData);
        // db 없는 데이터 테스트 임시
        Object.assign(personalSetting, modifyData);
        commit('setPersonalSetting', personalSetting);
    },
    getVideoBlurOptions: async ({ dispatch, commit, getters, rootGetters }) => {
        return await RoomUserVideoTrackFilter.getBlurOptions();
    },
    changeVideoBlur: async ({ dispatch, commit, getters, rootGetters }, data) => {
        await RoomUserVideoTrackFilter.changeBlurOptions(data);
    },
    uploadRoomImageFile: async ({ dispatch, commit, getters, rootGetters }, file) => {
        const res = await RoomCamStudy.getUploadImageSasUrl()
        const { roomImageUploadPath, presignedUrl } = res.data;
        if (!presignedUrl) {
            throw new Error('Could not get presigned URL');
        }

        const cancel = new AbortController()
        let removed = false
        try {
            await RoomFile.uploadToPresignedUrl({
                url: presignedUrl, file,
                onUploadProgress: e => {
                    if (removed) {
                        return
                    }
                },
                signal: cancel.signal
            })
            return roomImageUploadPath
        } catch (error) {
            cancel.abort()
            console.error('Error uploading file:', error)
            throw error
        }
    },
    modifyRoomImageUrl: async ({ dispatch, commit, getters, rootGetters }, data) => {
        return await RoomCamStudy.modifyRoomImageUrl(data)
    },
    changeWhiteNoiseStatus: async ({dispatch, commit, getters, rootGetters }, data) => {
        if(data?.whiteNoiseStatus === 'off') {
            commit('setCurrentWhiteNoise', {});
        }
        return await RoomCamStudy.changeWhiteNoiseStatus(data);
    },
    changeWhiteNoisePlayList: async ({dispatch, commit, getters, rootGetters }, whiteNoise) => {
        await RoomCamStudy.changeWhiteNoisePlayList({currentWhiteNoise: getters.currentWhiteNoise, whiteNoise});
        commit('setCurrentWhiteNoise', whiteNoise)
    },
    saveMyInfoSetting: async({dispatch, commit}, setting) => {
        localStorage.setItem(_my_info_setting, JSON.stringify(setting))
        commit('setMyInfoSetting', setting)
    },
    getCamStudyUserStopWatchSetting: async ({dispatch, commit, getters, rootGetters }, {roomId, userId}) => {
        const stopWatchSetting = await RoomCamStudy.getCamStudyUserStopWatchSetting(roomId, userId);
        commit('setStopWatchSetting', stopWatchSetting);
        return stopWatchSetting;
    },
    saveUserStopWatchSetting: async ({dispatch, commit, getters, rootGetters }, {roomId, sendEvent, data}) => {
        return await RoomCamStudy.saveUserStopWatchSetting(roomId, sendEvent, data);
    },
    modifyCamStudyMyMsg: async ({dispatch, commit, getters, rootGetters }, {roomId, userId, myMsg}) => {
        if(!userId) {
            userId = 'me';
        }
        return await RoomCamStudy.modifyCamStudyMyMsg(roomId, userId, myMsg);
    },
    getCamStudyUserInfo: async ({dispatch, commit, getters, rootGetters }, {roomId, userId}) => {
        if(!userId) {
            userId = 'me';
        }
        return await RoomCamStudy.getCamStudyUserInfo(roomId, userId);
    },
    getCamStudyMyMsg: async ({dispatch, commit, getters, rootGetters }, {roomId, userId}) => {
        return await RoomCamStudy.getCamStudyMyMsg(roomId, userId);
    },
    inviteUser: async ({dispatch, commit, getters, rootGetters }, data) => {
        return await RoomCamStudy.inviteUser(data);
    },
    isJoinedEmail: async ({dispatch, commit, getters, rootGetters }, email) => {
        return await RoomCamStudy.isJoinedEmail(email);
    },
    checkUserPremium: async ({dispatch, commit, getters, rootGetters}) => {
        const res = await RoomCamStudy.checkUserPremium();
        const isPremium = !!res?.data?.premium;
        commit('setPremiumUser', isPremium);
        commit('setUserPremiumLevel', res?.data);
        return res;
    },
    isAttendCheck: async ({rootGetters}) => {
        const roomId = rootGetters['room/room']?.roomId
        const attendCheckDate = JSON.parse(localStorage.getItem(_attend_check))?.[roomId]
        if(!attendCheckDate) return false

        const difference = Math.abs(new Date() - new Date(attendCheckDate));
        return difference <= 24 * 60 * 60 * 1000;
    },
    setAttendCheck: async ({rootGetters}) => {
        const roomId = rootGetters['room/room']?.roomId
        const attendCheck = JSON.parse(localStorage.getItem(_attend_check)) || {}
        const date = new Date();
        for(const key in attendCheck) {
            try {
                const value = new Date(attendCheck[key])
                if(Math.abs(new Date() - value) > 24 * 60 * 60 * 1000) {
                    delete attendCheck[key]
                }
            }catch (e) {
                console.error('',e)
                delete attendCheck[key]
            }
        }
        date.setHours(6, 0, 0, 0);
        attendCheck[roomId] = date
        localStorage.setItem(_attend_check, JSON.stringify(attendCheck))
    },
    resetAttendCheck: async ({rootGetters}) => {
        const roomId = rootGetters['room/room']?.roomId
        const attendCheck = JSON.parse(localStorage.getItem(_attend_check)) || {}
        delete attendCheck[roomId]
        localStorage.setItem(_attend_check, JSON.stringify(attendCheck))
    },
    changeCamStudyType: async ({dispatch, commit, getters, rootGetters }, data) => {
        return await RoomCamStudy.changeCamStudyType(data);
    },
    async changeCamStudyUserNickname({ dispatch, commit, getters, rootGetters }, data){
        return await RoomCamStudy.changeCamStudyUserNickname(data)
    },
    getCamStudyTrialInfo: async ({dispatch, commit, getters, rootGetters }) => {
        const response = await RoomCamStudy.getCamStudyTrialInfo();
        commit('setUserTrial', response.data.trialInfoList)
        return response;
    },
};
